import instanceAxios from '../config/api'
import {
  ExistingControl,
  ExistingControlResponse,
  MaturityRateResponse,
} from '../types/existingControlTypes'
const API_URL = '/existingControls'

export const getAllExistingControls = async ({
  search,
  page,
  pageSize,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<ExistingControlResponse>(
      `${API_URL}`,
      {
        params: {
          page,
          pageSize,
          search,
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch ExistingControl.')
  }
}
export const deleteExistingControlApi = async (ExistingControlId: string) => {
  try {
    const response = await instanceAxios.delete<ExistingControl[]>(
      `${API_URL}/` + ExistingControlId
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch existingControls.')
  }
}

export const addExistingControlApi = async (
  newExistingControl: ExistingControl
): Promise<ExistingControl> => {
  try {
    const response = await instanceAxios.post<ExistingControl>(
      `existingControls/`,
      newExistingControl
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to add ExistingControl.')
  }
}

export const getExistingControlbyIdApi = async (ExistingControlId: string) => {
  try {
    const response = await instanceAxios.get<ExistingControl>(
      `${API_URL}/` + ExistingControlId
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchExistingControl.')
  }
}

export const updateExistingControlApi = async (
  updateExistingControl: ExistingControl,
  _id: string
): Promise<ExistingControl> => {
  try {
    const response = await instanceAxios.put<ExistingControl>(
      `${API_URL}/${_id}`,
      updateExistingControl
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUTExistingControl.')
  }
}
export const getMaturityRateForExistingControls = async () => {
  try {
    const response = await instanceAxios.get<MaturityRateResponse>(
      `${API_URL}/getMaturityRateForExistingControls`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to getMaturityRateForExistingControls.')
  }
}
